import {useConfiguration} from '../hooks/useConfiguration'
import {Backdrop, Box, CircularProgress} from '@mui/material'
import TitleBar from './titlebar/TitleBar'
import QuickLaunch from './quicklaunch/QuickLaunch'
import MyProfileDialog from './profile/MyProfileDialog'
import React, {ReactNode} from 'react'
import useQuickLaunchType from '../hooks/useQuickLaunchType'
import {QuickLaunchType} from '../model/quickLaunch'

const contentSX = (quickLaunchType: QuickLaunchType) => {
  switch (quickLaunchType) {
    case 'left': {
      return {
        float: 'right',
        width: {sm: '100%', md: 'calc(100% - 63px)', xs: '100%'}
      }
    }
    case 'right': {
      return {
        float: 'left',
        width: {sm: '100%', md: 'calc(100% - 63px)', xs: '100%'}
      }
    }
    default: {
      return {float: 'left', width: '100%'}
    }
  }
}

export interface PortalProps {
  children?: ReactNode
}

export const Portal = (props: PortalProps) => {
  const [quickLaunchType] = useQuickLaunchType()
  const isLoadingConfig = useConfiguration()
  const isLoading = isLoadingConfig

  if (isLoading) {
    return (
      <Backdrop open={true}>
        <CircularProgress />
      </Backdrop>
    )
  }
  return (
    <Box
      sx={{backgroundColor: 'background.default'}}
      data-testid='MainApp:root'
    >
      <TitleBar />
      <Box display={'flex'}>
        {quickLaunchType === 'left' && <QuickLaunch />}

        <Box sx={contentSX(quickLaunchType)}>{props.children}</Box>

        {quickLaunchType === 'right' && <QuickLaunch />}
      </Box>
      <MyProfileDialog />
    </Box>
  )
}
